module.exports = __webpack_public_path__ + "aa02c77017f51bb2d4df245e42e0bc62.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/september-sale-banner.png
// module id = 534
// module chunks = 0